export enum ReportTypes {
    SUMMARY_REPORT = "SUMMARY_REPORT",
    WORK_FLOW_MANAGEMENT_SUMMARY_REPORT = "WORK_FLOW_MANAGEMENT_SUMMARY_REPORT",
    METADATA_SEARCH_REPORT = "METADATA_SEARCH_REPORT",
    INCIDENT_TRENDS_REPORT = "INCIDENT_TRENDS_REPORT",
}
